module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-editor-feedback"
    }
  }, [_c('div', {
    staticClass: "columns is-paddingless is-marginless"
  }, [_c('div', {
    staticClass: "column is-paddingless is-marginless is-narrow"
  }, [_c('feedback-editor', {
    attrs: {
      "header": _vm.tokens['lbl_speech'],
      "languages": _vm.speechLangs
    },
    model: {
      value: (_vm.speech),
      callback: function($$v) {
        _vm.speech = $$v
      },
      expression: "speech"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('bulma-checkbox', {
    attrs: {
      "label": _vm.tokens['lbl_word'],
      "disabled": !_vm.speech.language
    },
    model: {
      value: (_vm.speechAdjustForWordLength),
      callback: function($$v) {
        _vm.speechAdjustForWordLength = $$v
      },
      expression: "speechAdjustForWordLength"
    }
  })], 1)])]), _c('feedback-editor', {
    attrs: {
      "header": _vm.tokens['lbl_syllab'],
      "languages": _vm.syllabLangs
    },
    model: {
      value: (_vm.syllab),
      callback: function($$v) {
        _vm.syllab = $$v
      },
      expression: "syllab"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syllabMode),
      expression: "syllabMode"
    }],
    attrs: {
      "disabled": !_vm.syllab.language
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.syllabMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.syllabModes), function(mode) {
    return _c('option', {
      domProps: {
        "value": mode
      }
    }, [_vm._v(_vm._s(_vm.tokens[("item_" + mode)]))])
  }))])]), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('bulma-checkbox', {
    attrs: {
      "label": _vm.tokens['lbl_temp'],
      "disabled": !_vm.syllab.language
    },
    model: {
      value: (_vm.syllabTemporary),
      callback: function($$v) {
        _vm.syllabTemporary = $$v
      },
      expression: "syllabTemporary"
    }
  })], 1), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('bulma-checkbox', {
    attrs: {
      "label": _vm.tokens['lbl_word'],
      "disabled": !_vm.syllab.language
    },
    model: {
      value: (_vm.syllabAdjustForWordLength),
      callback: function($$v) {
        _vm.syllabAdjustForWordLength = $$v
      },
      expression: "syllabAdjustForWordLength"
    }
  })], 1)])]), _c('feedback-editor', {
    attrs: {
      "header": _vm.tokens['lbl_highlight']
    },
    model: {
      value: (_vm.highlight),
      callback: function($$v) {
        _vm.highlight = $$v
      },
      expression: "highlight"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('bulma-checkbox', {
    attrs: {
      "label": _vm.tokens['lbl_word'],
      "disabled": !_vm.highlight.language
    },
    model: {
      value: (_vm.highlightAdjustForWordLength),
      callback: function($$v) {
        _vm.highlightAdjustForWordLength = $$v
      },
      expression: "highlightAdjustForWordLength"
    }
  })], 1)])]), _c('feedback-editor', {
    attrs: {
      "header": _vm.tokens['lbl_warning'],
      "languages": _vm.speechLangs
    },
    model: {
      value: (_vm.warning),
      callback: function($$v) {
        _vm.warning = $$v
      },
      expression: "warning"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "control-line"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_phrase']))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.warningPhrase),
      expression: "warningPhrase"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": !_vm.warning.language
    },
    domProps: {
      "value": (_vm.warningPhrase)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.warningPhrase = $event.target.value
      }
    }
  })])])])], 1), _c('div', {
    staticClass: "column is-paddingless is-marginless"
  }, [_c('div', {
    staticClass: "columns is-paddingless is-marginless"
  }, [_c('div', {
    staticClass: "column is-paddingless is-marginless is-narrow"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_exceptions']))])]), _c('div', {
    staticClass: "column has-text-right is-paddingless is-marginless"
  }, [_c('i', {
    staticClass: "instruction"
  }, [_vm._v(_vm._s(_vm.tokens['lbl_example']) + " ")])])]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syllabExceptions),
      expression: "syllabExceptions"
    }],
    staticClass: "textarea exceptions",
    attrs: {
      "disabled": !_vm.syllab.language,
      "placeholder": _vm.tokens['lbl_syllabs']
    },
    domProps: {
      "value": (_vm.syllabExceptions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.syllabExceptions = $event.target.value
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b86d2b2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/taskEditorFeedback.vue
// module id = 410
// module chunks = 0